export default () => {

  const maxMobileSize = 768;
  const maxTabletSize = 1040;
  let windowWidth = window.innerWidth;
  let isMobile = false, isDesktop = false, isTablet = false;

  if (windowWidth <= maxMobileSize) {
    isMobile = true;
    fromTo('desktop', 'mobile');

  } else if (windowWidth <= maxTabletSize) {
    isTablet = true;
    fromTo('desktop', 'tablet');
  }
  else {
    isDesktop = true;
  }

  $(window).resize(() => {
    windowWidth = window.innerWidth;

    if (windowWidth <= maxMobileSize && !isMobile) {
      isMobile = true;
      isTablet = isDesktop = false;
      fromTo('tablet', 'mobile');


    } else if (windowWidth > maxMobileSize && windowWidth <= maxTabletSize && !isTablet && isDesktop) {
      isTablet = true;
      isMobile = isDesktop = false;
      fromTo('desktop', 'tablet');


    }
    else if (windowWidth > maxMobileSize && windowWidth <= maxTabletSize && !isTablet && isMobile) {
      isTablet = true;
      isMobile = isDesktop = false;
      fromTo('mobile', 'tablet');


    }
    else if (windowWidth > maxTabletSize && !isDesktop) {
      isDesktop = true;
      isMobile = isTablet = false;
      fromTo('tablet', 'desktop');

    }
    else if (windowWidth > maxMobileSize && !isTablet && !isDesktop) {
      isTablet = true;
      isMobile = isDesktop = false;
      fromTo('mobile', 'tablet');

    }
  });

  function fromTo(from, to) {
    $('.grid-show-in-' + from).each(function () {

      let id = $(this).data('id');
      let html = $(this).html();
      let that = $(this);

      $('.grid-show-in-' + to).each(function () {

        if ($(this).data('id') === id) {
          that.html("");
          $(this).html(html);
        }
      });
    });
  }
}


